import React, { useState, useEffect } from 'react';
import QuoteStore from '../../../../stores/QuoteStore';
import UserStore from '../../../../stores/UserStore';

export const useFileUploadFlow = ({
    setAuthModalVisible,
    setOpenModal,
    itarUploadAllowed = true,
    showITARRequiredError,
}: {
    setAuthModalVisible: (v: boolean) => void;
    setOpenModal: (v: boolean) => void;
    itarUploadAllowed?: boolean;
    showITARRequiredError?: () => void;
}) => {
    const shouldOpenMultiplePartsModal = (parts: any[]) => parts.length > 1;

    const handleUploadFile = (file: File) => {
        if (!itarUploadAllowed) {
            showITARRequiredError?.();
            return;
        }

        QuoteStore.addPart(file);

        if (!QuoteStore.rapidQuoteUid && !UserStore.isAuthenticated) {
            setAuthModalVisible(true);
            return;
        }

        if (shouldOpenMultiplePartsModal(QuoteStore.fileParts)) {
            setOpenModal(true);
        }
    };

    return { handleUploadFile };
};
